/**
 * Componente ErrorAlert que muestra una alerta de error con un mensaje personalizado.
 * @param {string} props.message - Mensaje de error que se mostrará en la alerta.
 */
const ErrorAlert = ({ message }) => {
  return (
    <div className="flex items-start gap-2 p-2 bg-red-100 text-red-700 border-l-4 border-r-4 border-red-400 rounded-lg shadow-sm mb-2 text-sm" role="alert">
      <svg className="w-4 h-4 mt-0.5 text-red-600" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.721-1.36 3.486 0l5.52 9.82c.746 1.327-.213 2.981-1.743 2.981H4.48c-1.53 0-2.49-1.654-1.744-2.981l5.52-9.82zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-2a1 1 0 01-.893-.553L9 10l.553-.894c.37-.642 1.333-.642 1.703 0L11 10l-.553.447A1 1 0 0110 11z" clipRule="evenodd"></path>
      </svg>
      <span>{message}</span>
    </div>
  );
};

export default ErrorAlert;

